import { getCountry } from '@iwIntlProvider/CountryProvider';
import { IconFileText } from '@iwoca/icons';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { DocumentTypeLabel } from './DocumentTypeLabel';
import { SHOW_UPLOAD_DOCUMENTS_MODAL } from '../../../modals/uploadDocumentsModal/UploadDocumentsModal.actions';
import { BANK_STATMENT_DOC_TYPE } from '../../../modals/uploadDocumentsModal/UploadDocumentsModalHelper';
import UploadButton from '../../../ui/uploadButton/UploadButton';
import { useGetTradingHistoryData } from '../../useGetTradingHistoryData';
import { Document } from '../Document/Document';
import { DocumentReview } from '../Document/DocumentReview';
import { DocumentsMissing } from '../Document/DocumentsMissing';

const mapDispatchToProps = (dispatch) => ({
    uploadDocByType: (
        documentType,
        preventBackNavigation,
        feedbackIds,
        applicationId
    ) =>
        dispatch({
            type: SHOW_UPLOAD_DOCUMENTS_MODAL,
            documentType,
            preventBackNavigation,
            feedbackIds,
            applicationId
        })
});

const DocumentsByType = (props) => {
    const { documentType } = props;
    const {
        documentTypes,
        documentFeedback,
        applicationId,
        isDocumentsRefetching
    } = useGetTradingHistoryData();

    const isDE = getCountry() === 'DE';

    const getDocument = () => {
        return _.find(documentTypes, ['value', documentType]);
    };

    const handleUploadDocument = (feedbackIds = null) => {
        const document = getDocument();
        const preventBackNavigation = feedbackIds ? true : false;

        props.uploadDocByType(
            document,
            preventBackNavigation,
            feedbackIds,
            applicationId
        );
    };

    const renderDocuments = () => {
        const { documents } = props;
        const sortedDocuments = _.sortBy(
            documents,
            (doc) => doc.attributes.uploaded_at
        );

        return _.map(sortedDocuments, (document) =>
            isDE && document.attributes?.document_feedback?.length > 0 ? (
                <DocumentReview
                    key={document.id}
                    document={document}
                    onUpload={handleUploadDocument}
                    applicationId={applicationId}
                    isRefetching={isDocumentsRefetching}
                />
            ) : (
                <Document key={document.id} document={document} />
            )
        );
    };

    const documentsList = renderDocuments();
    const document = getDocument();

    const displayMissingCoverages =
        isDE &&
        documentType === BANK_STATMENT_DOC_TYPE.value &&
        documentFeedback?.doc_requirement_reviews?.some((review) => {
            return review.bank_account_coverages.length > 0;
        });

    return (
        <div
            className="mb-3xl bg-structure-100"
            data-testid="document-type-card"
        >
            <div className="flex items-center justify-between border-b border-secondary-90 p-l">
                <div className="flex items-center gap-l text-xl">
                    <IconFileText />
                    <span
                        className="text-l font-bold"
                        data-testid="document-type"
                    >
                        {document && (
                            <DocumentTypeLabel label={document.label} />
                        )}
                    </span>
                </div>

                <UploadButton onClick={handleUploadDocument} />
            </div>
            <div className="flex flex-col gap-m px-l pb-l">
                <div
                    className="flex items-center justify-between p-l text-m font-bold"
                    data-testid="document-heading"
                >
                    <span>
                        <FormattedMessage
                            id="_.trading_data.uploaded_documents.document_name"
                            defaultMessage="Name"
                        />
                    </span>
                    <span>
                        <FormattedMessage
                            id="_.trading_data.uploaded_documents.document_uploaded_date"
                            defaultMessage="Upload Date"
                        />
                    </span>
                </div>
                {documentsList}
            </div>
            {displayMissingCoverages && (
                <DocumentsMissing onUpload={handleUploadDocument} />
            )}
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(DocumentsByType);
